<template>
    <b-modal
      centered
       :hide-footer="true"
      modal-class="c-wrap"
      dialog-class="c-dialog"
      content-class="c-content"
      header-class="popup_header"
      body-class="c-body container"
      :visible="visible"
      @hide="onCancel"
    >
      <template #modal-header="{ close }" style="width: 100%; display: flex; justify-content: center">
        <span style="margin: auto; margin-left: 200px;">{{$c.COMMUNITY_CATEGORY1[type]}}</span>
        <b-img class="mo_close_btn"  @click="onCancel" :src="require('../../../assets/image/ic_close2.png')" style="margin-right: 15px;"/>
      </template>
      <div style="display: flex; flex-direction: column; height: 100%">
        <div style="flex: 1; overflow-y: auto">
          <div  style="display:flex; flex-wrap: nowrap; justify-content: space-between">
            <div>
              <b-button :class="['setting_btn', anony == 'N'?'':'disable']"
                        :disabled="anony == 'N' ? false : true"
                        variant="primary"
                        style="margin-right:0.5em;"
                        @click="onCopy"
              >
                {{$t('community.call')}}
              </b-button>
              <!--
              <b-button :class="['setting_btn', anony == 'N'?'':'disable']"
                        :disabled="anony == 'N' ? false : true"
                        variant="primary">
                {{$t('community.send_msg')}}
              </b-button>
              -->
              <span v-if="myinfo.isAdmin()" class="popup_title" style="margin-left: 10px;">{{id}}</span>
            </div>
            <b-form-input v-if="myinfo.isAdmin() || anony == 'N'" type="text" readonly class="input input-text" style="text-align:center;width: 145px; height: 40px; background-color: #eeeeef; font-size: 16px; font-family: KoreanGD15R;"
                          :value="Utils.formatPhoneNumber(phone)"></b-form-input>
          </div>
          <b-form-input type="text" readonly class="input-title" :value="replaceEnter(title)" style="margin-top: 11px;">
          </b-form-input>
          <!--<b-form-input type="text" readonly class="input-title"  :value="content" style="margin-top: 10px">
          </b-form-input>-->
          <div
            class="textarea_wrapper form-control"
            style="margin-top: 13px; padding: 8px; line-height: 28px; max-height: 500px; height: auto; overflow-y: auto; white-space: pre-wrap"
            v-model="content"
            readonly
          >{{content}}</div>
          <div  align="center" @click="carouselClick" style="width: 100%;padding-top:0.6em">
<!--            <CCarousel
              id="carousel-1"
              :interval="0"
              v-model="currentImage"
            >
              <b-carousel-slide
                v-for="image in images"
                :img-src="image">
                <template slot="img">
                  <div class="slide-content" style="height: 300px">
                    <b-img
                      style="max-width: 100%; max-height: 100%;"
                      :src="image"
                    />
                  </div>
                </template>
              </b-carousel-slide>
            </CCarousel>-->
            <b-img
              v-for="image in images"
              style="max-width: 100%; width: 100%; height: auto; margin-bottom: 5px"
              :src="image"
            />
          </div>
          <div style="display: flex; padding-bottom:5px;justify-content: space-between; align-items: center;">
            <span class="comment">{{$t('community.comment')}}</span>
            <!--
            <div>
              <b-button @click="onReportPrevent('R')" variant="primary" class="add_btn" style="margin-right:0.2em;">{{$t('community.report_btn')}}</b-button>
              <b-button @click="onReportPrevent('P')" variant="primary" class="add_btn">{{$t('community.prevent_btn')}}</b-button>
            </div>
            -->
          </div>
          <div class="comment-list-wrap">
            <div v-for="(cmt, i) in comment_list"
                 :key="i"
                 class="comment-list-item">
              <div class="comment-list-item-inner">
                <div style="flex: 1">
                  <span class="cell_num">{{i + 1}}.</span>
                  <span class="cell_num">{{cmt.f_anony == 'N' ? cmt.f_user_name : $t("community.anony")}}</span>
                  <span v-if="cmt.f_user_idx == writer_idx" class="charter_badge" >{{$t("community.anony_writer")}}</span>
                  <span class="cell_time">{{cmt.f_reg_time}}</span>
                </div>
                <div v-if="(cmt.f_user_idx == myinfo.uid || myinfo.isAdmin())">
                  <b-button @click="onEditComment(cmt)" variant="white" class="cell_btn" style="margin-right:0.2em;">{{$t('common.modify1')}}</b-button>
                  <b-button @click="onDelComment(cmt.f_idx)" variant="white" class="cell_btn">{{$t('common.delete1')}}</b-button>
                </div>
              </div>
              <div class="cell_content">
                <span>{{cmt.f_comment}}</span>
              </div>
            </div>
          </div>
          <b-form-textarea
            style=""
            class="c-textarea"
            v-model="comment_content"
            :placeholder="$t('community.comment_placeholder')" rows="5"></b-form-textarea>
          <div class="leftright">
            <md-single-check-box
              :label="$t('community.anony')"
              v-model="comment_anony" style="display: inline;float: left" variant="red"/>
            <div style="display: contents;">
          <span class="comment_guide">
          {{$t('community.comment_guide')}}
          </span>
              <b-button @click="onAddComment" class="add_btn" >{{$t('community.regist')}}</b-button>
            </div>
          </div>
        </div>
      </div>
      <div class="c-footer" v-if="mine">
        <b-button @click="onLocalDelete" class="footer-btn" style="background: #cacbcd">{{$t('common.delete')}}</b-button>
        <b-button @click="onLocalEdit" variant="primary" class="footer-btn">{{$t('common.modify')}}</b-button>
      </div>
      <Gallery :src="images" :current="currentImage" :visible.sync="showGallery"/>
    </b-modal>
</template>

<script>
import Utils from "../../../config/utils";
import MdSingleCheckBox from "../mf/MdSingleCheckBox";
import Gallery from "../Gallery";
import CCarousel from "../CCarousel";

export default {
  name: "CommunityDetailPopup",
  components: {MdSingleCheckBox, Gallery, CCarousel},
  props:["visible", "info", "onDelete", "onEdit"],
  data() {
    return {
      showGallery:false,
      Utils:Utils,
      id:null,
      type:'',
      title:"",
      phone:"",
      anony:"N",
      made:'N',
      push:'N',
      comment_anony:false,
      writer_idx:"",
      content:"",
      images:[],
      image_url: '',
      comment_list:[],
      mine:false,
      comment_id:0,
      comment_content:"",
      currentImage:0,
    }
  },
  inject: ['eventBus'],
  methods:{
    onCopy(){
      Utils.callPhone(this, this.phone, '');
    },
    onShow(){
      this.eventBus.$emit('setModal', this);
      window.history.pushState('forward', null, );
      if (this.info == null) {
        this.onCancel();
      } else {
          this.id = this.info.f_idx;
          this.getInfo();
      }
    },

    onReportPrevent(type){
      if (type == 'P')
      {
        Utils.showConfirm(
          this,
          this.$t("community.ask_prevent"),
        ).then(
          value => {
            if (value){
              Utils.requestPost(
                this.$c.API.Community.reportOrPreventCommunity,
                {
                  community_idx: this.id,
                  type: type,
                  user_idx: this.myinfo.uid,
                },
              ).then(result => {
                if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                  this.onCancel();
                } else {
                  Utils.toast(this, result.msg);
                }
              });
            }
          }
        );
      } else {
        Utils.requestPost(
          this.$c.API.Community.reportOrPreventCommunity,
          {
            community_idx: this.id,
            type: type,
            user_idx: this.myinfo.uid,
          },
        ).then(result => {
          if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            Utils.toast(this, this.$t("community.report_success"));
          } else {
            Utils.toast(this, result.msg);
          }
        });
      }

    },

    onCancel(){
      if(window.history.state == "forward")
        window.history.back();
    },

    replaceEnter(text){
      return text.replace(/\n/g, " ");
    },
    onEditComment(cmt){
      this.comment_id = cmt.f_idx;
      this.comment_content = cmt.f_comment;
    },

    onDelComment(idx){
      if (this.$store.getters.isLoading) {
        return;
      }

      Utils.showConfirm(
        this,
        '<span style="font-size:22px;">'+this.$t("community.delete_comment_confirm")+'</span>',
      ).then(value=>{
        if (value){
            Utils.requestPost(
              this.$c.API.Community.removeCommunityComment,
              {
                community_idx: this.id,
                comment_idx: idx
              }
            ).then(result => {
              if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                this.getInfo();
              } else {
                Utils.toast(result.msg);
              }
            });
        }
      });
    },

    onAddComment(){
      if (this.$store.getters.isLoading) {
        return;
      }

      if (this.comment_content == '') {
        Utils.toast(this.$t("community.comment_placeholder"));
        return;
      }

        Utils.requestPost(
          this.comment_id == 0 ? this.$c.API.Community.addCommunityComment : this.$c.API.Community.updateCommunityComment,
          {
            community_idx: this.id,
            comment_idx: this.comment_id,
            comment: this.comment_content,
            anony: this.comment_anony? 'Y' : 'N',
          }
        ).then(result => {
            if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                this.comment_id = 0;
                this.comment_content = '';
                this.getInfo()
            } else {
              Utils.toast(this, result.msg);
            }
        });
    },
    onLocalEdit(){
      this.$emit('edit');
    },
    onLocalDelete(){
      if (this.$store.getters.isLoading) {
        return;
      }

      Utils.showConfirm(
        this,
        '<span style="color:#cf0000;">'+this.$t("community.delete_confirm")+'</span>',
      ).then(value=>{
        if(value){
          Utils.requestPost(
              this.$c.API.Community.removeCommunity,
              {
                idx_list: JSON.stringify([this.id]),
              }
            ).then(result => {
                if (result.code == this.$c.API_RES_CODE.SUCCESS) {
                  this.onDelete();
                } else {
                  Utils.toast(this, result.msg);
                }
            });
        }
      });
    },
    carouselClick(){
      this.showGallery = true;
    },
    getInfo(){
      Utils.requestGet(
        this.$c.API.Community.getCommunityDetail,
        {
          community_idx: this.id
        }
      ).then(result => {
        if (result.code == this.$c.API_RES_CODE.SUCCESS) {
            this.id = result.data.f_idx;
            this.type = result.data.f_type;
            this.title = result.data.f_title;
            this.made = result.data.f_made;
            this.push = result.data.f_push;
            this.phone = result.data.f_phone;
            this.anony = result.data.f_anony;
            this.writer_idx = result.data.f_user_idx;
            this.content = result.data.f_content;
            this.image_url = result.data.f_image_url;
            this.images = result.data.f_image_url.split(',').filter(it => {
              return it != ''
            });
            this.comment_list = result.data.comment_list;
            this.mine = result.data.f_user_idx == this.myinfo.uid || this.myinfo.isAdmin();
        } else {
          Utils.toast(this,result.msg);
        }

      });
    },
  },
  watch: {
    visible: function (){
      if (this.visible)
        this.onShow();
    }
  }

}
</script>

<style lang="scss">
.c-header{
  justify-content: center;
  display: flex;
  padding: 0;
  height: 48px;
  align-items: center;
  border-bottom: solid 1px #eeeded;
}

.slide-item>img{
  height: 100%;
  width: initial!important;
}

.slide-item{
  height: 350px;
}

//.c-header>button{
//  padding: 0;
//}
</style>

<style scoped lang="scss">
@import "../../../assets/css/vars";

.setting_btn {
  align-items: center;
  justify-content: center;
  background-color: $c_457fff;
  border-radius: 5px;
  width: 85px;
  height: 36px;
  font-size: $fs_16;
  padding: 0;
  font-family: $korean_gd_15_r;
}

.add_btn {
  height: 36px;
  width: 70px;
  margin-top: 5px;
  background-color: #0840ba;
  border-radius: 4px;
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
  color: white;
  float: right;
}


.disable{
  background-color: #ddddde!important;
}



.comment{
  font-size: $fs_16;
  font-family: $korean_gd_15_r;
}

.cell_btn{
  padding: 0;
  width: 45px;
  height: 24px;
  align-items: center;
  justify-content: center;
  background-color: #f9f7f7;
  border-radius: 2px;
  border-color: #e5e5e5;
  border-width: 0.5px;
  color: $black;
  font-size: $fs_15;
  font-family: $korean_gd_14_r;
}

.comment-list-item{
  padding: 0.5em;
  border-top: solid 1px #eeeeef;
}

.comment-list-wrap{
  border-bottom: solid 1px #eeeeef;

}
.comment-list-item-inner{
 display: flex;
 margin-bottom: 3px;
}

.comment-list-item-text{

}

.cell_num{
  color: $black;
  font-size: $fs_17;
  font-family: $korean_gd_15_r;
}

.cell_time{
  color: #7a7a7a;
  font-size: $fs_14;
  font-family: $korean_gd_12_r;
  margin-left: 8px;
}

.cell_content{
  color: $black;
  font-size: $fs_16;
  font-family: $korean_gd_12_r;
  line-height: 20px;
  word-break: break-all;
  white-space: pre-line;
}

.charter_badge{
  margin-left: 3px;
  background-color: $primary;
  width: 50px;
  height: 30px;
  border-radius: 5px;
  align-items: center;
  justify-content: center;
  color: $white;
  font-size: $fs_14;
  font-family: $korean_gd_15_r;
  padding: 5px;
}

.c-textarea{
  margin-top: 11px;
  padding:8px;
  color: $black;
  font-size: $fs_16;
  font-family: $korean_gd_12_r;
  line-height: 24px;
}
::placeholder{
  color: #9d9393;
}
.comment_guide{
  color: $trading1;
  font-size: $fs_15;
  font-family: $korean_gd_13_r;
  margin-right: -30px;
  margin-top: 10px;
}
.c-footer{
  width: 480px;
  bottom: 0;
  height: 50px;
  display: flex;
  position: absolute;
  left: -2px;
}

.footer-btn{
  background: $c_457fff;
  flex: 1;
  margin: 0;
  border-radius: 0;
  font-size: $fs_18;
  font-family: $korean_gd_15_r;
}

.leftright{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 60px
}

.input-title{
  font-size: $fs_17;
  font-family: $korean_gd_15_r;
  height: 40px;
}

.textarea_wrapper{
  font-size: $fs_17;
  font-family: $korean_gd_14_r;
}

</style>



// WEBPACK FOOTER //
// src/components/controls/popup/CommunityDetailPopup.vue